<!--  -->
<template>
  <div style="padding: 20px;">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="推广链接" name="link" />
      <el-tab-pane label="提现配置列表" name="config" />
      <el-tab-pane label="提现记录列表" name="withdraw" />
      <el-tab-pane label="金币记录列表" name="coin" />
      <el-tab-pane label="聊天记录" name="chat" />
      <el-tab-pane label="数据源" name="datasource" />
    </el-tabs>

    <!-- 提现配置列表 -->
    <div v-show="activeTab === 'config'" v-loading="configLoading">
      <div style="margin-bottom: 12px;">
        <el-button type="primary" size="small" @click="openCreateConfig">创建配置</el-button>
      </div>
      <el-table :data="configList" border style="width: 100%">
        <el-table-column prop="title" label="标题" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="account_name" label="小程序名称" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="app_id" label="小程序APPID" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column label="获得金币" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.config_result ? row.config_result.coin : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="递减比例（%）" width="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.config_result">
              {{ row.config_result.decrease_start }}% ~ {{ row.config_result.decrease_end }}%
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="汇率（1元）" width="140" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.config_result">
              {{ row.config_result.exchange_rate }} 金币
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="可提现规则" min-width="260" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.config_result && row.config_result.withdrawal_rules && row.config_result.withdrawal_rules.length">
              <div
                v-for="(rule, idx) in row.config_result.withdrawal_rules"
                :key="idx"
                class="withdrawal-tag"
              >
                {{ rule.many_day }}天 / {{ rule.many_day_number }}次 /
                {{ configFenToYuan(rule.withdrawal_amount) }}元
              </div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="是否默认" width="120" align="center">
          <template slot-scope="{ row }">
            <el-switch
              :value="row.config_default === 2"
              active-color="#13ce66"
              inactive-color="#dcdfe6"
              @change="val => handleToggleDefault(row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="openEditConfig(row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDeleteConfig(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        v-if="activeTab === 'config'"
        :current-page="configQuery.page"
        :page-sizes="[10, 20, 50]"
        :total="configTotal"
        @size-change="configSizeChange"
        @current-change="configPageChange"
      />
    </div>

    <!-- 提现记录列表 -->
    <div v-show="activeTab === 'withdraw'" v-loading="withdrawLoading">
      <el-table :data="withdrawList" border style="width: 100%">
        <el-table-column prop="account_name" label="小程序名称" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="app_id" label="小程序APPID" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="coin" label="获得金币" width="100" align="center" />
        <el-table-column label="提现金额（元）" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row.withdraw_amount }}
          </template>
        </el-table-column>
        <el-table-column prop="open_id" label="openid" min-width="220" align="center" show-overflow-tooltip />
        <el-table-column prop="created_at_text" label="创建时间" min-width="160" align="center" show-overflow-tooltip />
      </el-table>
      <pagination-right
        v-if="activeTab === 'withdraw'"
        :current-page="withdrawQuery.page"
        :page-sizes="[10, 20, 50]"
        :total="withdrawTotal"
        @size-change="withdrawSizeChange"
        @current-change="withdrawPageChange"
      />
    </div>

    <!-- 金币记录列表 -->
    <div v-show="activeTab === 'coin'" v-loading="coinLoading">
      <el-table :data="coinList" border style="width: 100%">
        <!-- <el-table-column type="index" label="序号" width="60" align="center" /> -->
        <el-table-column prop="account_name" label="小程序名称" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="app_id" label="小程序APPID" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="open_id" label="openid" min-width="220" align="center" show-overflow-tooltip />
        <el-table-column prop="business_type_text" label="业务类型" min-width="100" align="center" show-overflow-tooltip />
        <!-- <el-table-column prop="change_type_text" label="变动类型" min-width="100" align="center" show-overflow-tooltip /> -->
        <el-table-column label="本次变更金币" width="140" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.change_type === 1 || row.change_type === '1'">+{{ row.coin }}</span>
            <span v-else>-{{ row.coin }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coin_balance" label="变更后金币余额" width="140" align="center" />
        <el-table-column prop="remark" label="备注" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="created_at_text" label="创建时间" min-width="160" align="center" show-overflow-tooltip />
      </el-table>
      <pagination-right
        v-if="activeTab === 'coin'"
        :current-page="coinQuery.page"
        :page-sizes="[10, 20, 50]"
        :total="coinTotal"
        @size-change="coinSizeChange"
        @current-change="coinPageChange"
      />
    </div>

    <!-- 聊天记录 -->
    <div v-show="activeTab === 'chat'" v-loading="chatLoading">
      <div style="margin-bottom: 12px; display:flex; gap:10px;">
        <el-button type="primary" size="small" @click="openChatCreate">创建聊天记录</el-button>
      </div>
      <el-table
        :data="chatList"
        border
        style="width: 100%"
        @selection-change="onChatSelectionChange"
      >
        <el-table-column label="类型" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.chat_type === 1 || row.chat_type === '1'">文本</span>
            <span v-else-if="row.chat_type === 2 || row.chat_type === '2'">图片</span>
            <span v-else-if="row.chat_type === 3 || row.chat_type === '3'">图文</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="内容" min-width="260" align="left">
          <template slot-scope="{ row }">
            <div v-if="row.chat_type === 1 || row.chat_type === '1'">
              <div v-if="Array.isArray(row.content)">
                <div v-for="(line, idx) in row.content" :key="idx">{{ line }}</div>
              </div>
              <div v-else>{{ row.content || '' }}</div>
            </div>
            <div v-else-if="row.chat_type === 2 || row.chat_type === '2'">
              <div style="display:flex; flex-wrap: wrap; gap:8px;">
                <el-image
                  v-for="(u, idx) in normalizeChatImg(row.img)"
                  :key="idx"
                  :src="u"
                  :preview-src-list="normalizeChatImg(row.img)"
                  fit="cover"
                  style="width: 60px; height: 60px; border-radius: 6px; border: 1px solid #ebeef5;"
                />
                <span v-if="normalizeChatImg(row.img).length === 0">-</span>
              </div>
            </div>
            <div v-else-if="row.chat_type === 3 || row.chat_type === '3'">
              <div v-for="(n, idx) in normalizeChatNews(row.news)" :key="idx" style="display:flex; align-items:center; gap:10px; margin-bottom:6px;">
                <span style="max-width: 260px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ n.content }}</span>
                <el-image
                  v-if="n.img"
                  :src="n.img"
                  :preview-src-list="[n.img]"
                  fit="cover"
                  style="width: 60px; height: 60px; border-radius: 6px; border: 1px solid #ebeef5;"
                />
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="created_at_text" label="创建时间" width="160" align="center" />
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="openChatEdit(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteChat(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        v-if="activeTab === 'chat'"
        :current-page="chatQuery.page"
        :page-sizes="[10, 20, 50]"
        :total="chatTotal"
        @size-change="chatSizeChange"
        @current-change="chatPageChange"
      />
    </div>

    <!-- 聊天记录弹窗（创建/编辑） -->
    <el-dialog
      :title="chatDialogMode === 'create' ? '创建聊天记录' : '编辑聊天记录'"
      :visible.sync="chatDialogVisible"
      width="720px"
      :close-on-click-modal="false"
      @close="resetChatDialog"
    >
      <el-form ref="chatFormRef" :model="chatForm" label-width="110px">
        <el-form-item label="类型">
          <el-select v-model="chatForm.chat_type" placeholder="请选择" :disabled="chatDialogMode === 'edit'">
            <el-option :value="1" label="文本" />
            <el-option :value="2" label="图片" />
            <el-option :value="3" label="图文" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="chatForm.chat_type === 1" label="文本内容">
          <el-input
            v-model="chatForm.contentText"
            type="textarea"
            :rows="6"
            placeholder="每行一条，第一行=数组第一项"
          />
        </el-form-item>

        <el-form-item v-if="chatForm.chat_type === 2" label="图片数组">
          <div style="display:flex; gap:10px; margin-bottom:8px;">
            <el-button size="mini" type="primary" :disabled="chatDialogMode === 'edit'" @click="addChatImgItem">增加一项</el-button>
          </div>
          <div v-for="(u, idx) in chatForm.imgArr" :key="idx" style="display:flex; gap:10px; align-items:center; margin-bottom:8px;">
            <div style="display:flex; align-items:center; gap:10px;">
              <el-image
                v-if="chatForm.imgArr[idx]"
                :src="chatForm.imgArr[idx]"
                :preview-src-list="[chatForm.imgArr[idx]]"
                fit="cover"
                style="width: 80px; height: 80px; border-radius: 6px; border: 1px solid #ebeef5;"
              />
              <div v-else style="width: 80px; height: 80px; border-radius: 6px; border: 1px dashed #dcdfe6; display:flex; align-items:center; justify-content:center; color:#909399; font-size:12px;">
                未选择
              </div>
            </div>
            <el-button size="mini" type="success" @click="openChatImgPicker(idx)">素材库选择/上传</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              :disabled="chatForm.imgArr.length <= 1"
              @click="removeChatImgItem(idx)"
            />
          </div>
        </el-form-item>

        <el-form-item v-if="chatForm.chat_type === 3" label="图文内容">
          <div style="display:flex; gap:10px; margin-bottom:8px;">
            <el-button size="mini" type="primary" :disabled="chatDialogMode === 'edit'" @click="addNewsItem">增加一条</el-button>
          </div>
          <div v-for="(it, idx) in chatForm.newsItems" :key="idx" style="display:flex; gap:10px; margin-bottom:8px; align-items:center;">
            <el-input v-model="it.content" placeholder="文本内容" style="width: 240px" />
            <div style="flex: 1; display:flex; align-items:center; gap:10px;">
              <el-image
                v-if="it.img"
                :src="it.img"
                :preview-src-list="[it.img]"
                fit="cover"
                style="width: 60px; height: 60px; border-radius: 6px; border: 1px solid #ebeef5;"
              />
              <div v-else style="width: 60px; height: 60px; border-radius: 6px; border: 1px dashed #dcdfe6; display:flex; align-items:center; justify-content:center; color:#909399; font-size:12px;">
                未选择
              </div>
            </div>
            <el-button size="mini" type="success" @click="openChatNewsImgPicker(idx)">素材库选择/上传</el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              :disabled="chatForm.newsItems.length <= 1"
              @click="removeNewsItem(idx)"
            />
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="chatDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="chatSubmitting" @click="submitChatDialog">确定</el-button>
      </span>
    </el-dialog>

    <div v-show="activeTab == 'link'" class="right_box">
      <div class="search_box">
        <div class="search_box">
          <el-input
            v-model="objr.keywords"
            style="width:300px;"
            placeholder="请输入"
          />
          <el-select
            v-model="objr.onlyMe"
            :disabled="true"
            placeholder="请选择"
            style="width:300px;"
          >
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="objr.default_a"
            placeholder="请选择"
            style="width:300px;"
          >
            <el-option
              v-for="item in defaultarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            style=""
            icon="el-icon-search"
            @click="sraw"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="awered"
          >重置</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleBatchDelete"
          >删除</el-button>
        </div>
        <div>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addbit"
          >添加</el-button>
        </div>
      </div>
      <el-table
        :key="activeTab"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%;margin-top:20px"
        max-height="800"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        <el-table-column
          prop="title"
          label="标题"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.title }}
            <i
              v-clipboard:copy="formatCopy(scope.row)"
              v-clipboard:success="onCopys"
              v-clipboard:error="onErrors"
              class="el-icon-document-copy"
              style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer;"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="iqiyi_promotion_link_no"
          label="编号"
          width="200"
          align="center"
        />
        <el-table-column
          prop="app_id"
          label="小程序appid"
          width="320"
          align="center"
        >
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; justify-content: center; gap: 6px; flex-wrap: wrap;">
              <span>
                {{ scope.row.app_id }}（{{ scope.row.account_name }}）
                <span
                  v-if="scope.row.operation_status != 1"
                  style="color: #F56C6C;"
                >
                  ({{ scope.row.operation_status_text }})
                </span>
              </span>
              <el-button
                type="primary"
                size="mini"
                @click="lookdata(scope.row)"
              >
                页面数据
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="page_path"
          label="内推链接"
          width="400"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.action_sets && scope.row.action_sets.length > 0" style="position: relative; min-height: 60px; padding-bottom: 28px;">
              <div style="margin-bottom: 8px; word-break: break-all;">{{ getActionSetLink(scope.row, 0) }}</div>
              <div style="position: absolute; bottom: 0; left: 0; right: 0; display: flex; gap: 4px;">
                <el-button
                  v-if="scope.row.action_sets.length > 1"
                  type="primary"
                  size="mini"
                  style="flex: 1; width: 50%;"
                  @click="openActionSetsDialog(scope.row)"
                >
                  更多
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  :style="scope.row.action_sets.length > 1 ? 'flex: 1; width: 50%;' : 'width: 100%;'"
                  @click="copyToClipboard(getActionSetLink(scope.row, 0))"
                >
                  复制
                </el-button>
              </div>
            </div>
            <div v-else style="text-align: center;">
              <el-button
                type="primary"
                size="mini"
                @click="openSetDataSource(scope.row)"
              >
                设置数据源
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="url_link"
          label="外推链接"
          width="250"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.url_link }}
            <i
              v-if="scope.row.url_link!=''"
              v-clipboard:success="onCopys"
              v-clipboard:error="onErrors"
              v-clipboard:copy="scope.row.url_link"
              class="el-icon-document-copy"
              style="color: #165DFF;border: 0;font-size: 14px;cursor: pointer;"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="default_a"
          label="默认A页"
          align="center"
          width="70"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.default_a"
              :active-value="2"
              :inactive-value="1"
              active-color="#13ce66"
              @change="unBindStatusUpdate($event,scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          align="center"
          width="200"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">

            <el-button
              type="text"
              style="margin-bottom:10px;color:#165dff;"
              @click="getDelayedMsg(scope.row)"
            >延时消息</el-button>
            <el-button
              type="text"
              style="margin-bottom:10px;color: #13ce66;"
              @click="exportledit(scope.row)"
            >修改</el-button>
            <el-button
              type="text"
              style="margin-bottom:10px;color: #e6a23c;"
              @click="reusedawrq(scope.row)"
            >复用</el-button>
            <el-button
              type="text"
              style="margin-bottom:10px;color: #f78989;"
              @click="exportlisrwdaw(scope.row.iqiyi_promotion_link_no)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="activeTab === 'link'"
        style="text-align: right;margin-top: 10px;"
        background
        :current-page="objr.page"
        :page-size="objr.pageSize"
        :page-sizes="[10, 30, 50, 100]"
        :total="newtotalr"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="fetchPageSizer"
        @current-change="fetchCurrentPager"
      />

    </div>

    <div v-show="activeTab == 'datasource'" class="right_box">
      <div class="search_box">
        <div class="search_box">
          <el-input
            v-model="configSearch.app_id"
            style="width:300px;"
            placeholder="请输入appid"
          />
          <el-input
            v-model="configSearch.user_action_set_id"
            style="width:300px;"
            placeholder="请输入数据源ID"
            clearable
            @keyup.enter.native="loadConfigList"
          />
          <el-button
            type="primary"
            style=""
            icon="el-icon-search"
            @click="loadConfigList"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="resetConfigPage"
          >重置</el-button>
          <el-button
            type="success"
            icon="el-icon-refresh"
            @click="openSyncDialog"
          >同步数据源</el-button>
        </div>
      </div>

      <!-- 列表 -->
      <el-table v-loading="globalLoading" :data="configListnew" border style="width:100%;margin-top:20px;">
        <el-table-column prop="app_id" label="小程序Appid/名称" align="center" width="300">
          <template slot-scope="scope">
            {{ scope.row.app_id_str }}（{{ scope.row.official_account_name }}）
          </template>
        </el-table-column>
        <el-table-column prop="account_id" label="广告主名称/ID" align="center">
          <template slot-scope="scope">
            {{ scope.row.account_name }}({{ scope.row.account_id }})
          </template>
        </el-table-column>
        <el-table-column prop="name" label="数据源名称" align="center" />
        <el-table-column prop="user_action_set_id" label="数据源ID" align="center" />
        <el-table-column prop="secret_key" label="SecretKey" align="center" />
        <el-table-column prop="hk_default" align="center" width="120">
          <template slot="header">
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="white-space: pre-line;">
                默认数据源什么时候生效

                1、推广链接未绑定数据源时，会根据小程序appid关联上默认的记录

                2、推广链接已经绑定了数据源，数据源被停用时。
              </div>
              <span style="cursor: pointer; display: inline-flex; align-items: center; gap: 4px;">
                是否默认
                <i class="el-icon-question" style="color: #909399;" />
              </span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.hk_default"
              :active-value="2"
              :inactive-value="1"
              active-color="#13ce66"
              @change="handleHkDefaultChange($event, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="hk_status" align="center" width="120">
          <template slot="header">
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="white-space: pre-line;">
                已经在投的数据源停用后将会使用默认的
              </div>
              <span style="cursor: pointer; display: inline-flex; align-items: center; gap: 4px;">
                状态
                <i class="el-icon-question" style="color: #909399;" />
              </span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.hk_status"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              @change="handleHkStatusChange($event, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" style="color:#165dff;" @click="openUpdateSecret(scope.row)">更新SecretKey<span v-if="scope.row.secret_key==''" style="color: red;">（请及时更新）</span></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <pagination-right
        v-if="activeTab === 'datasource'"
        ref="configPagination"
        :current-page="configSearch.page"
        :page-sizes="[10,20,50]"
        :total="configTotalnew"
        @size-change="changeConfigPageSize"
        @current-change="changeConfigPage"
      />
    </div>

    <withdraw-dialog ref="withdrawDialog" @success="fetchConfigList" />
    <el-dialog
      title="推广链接"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      wdith="990px"
    >
      <activation
        ref="activationview"
        @updata="updata"
      />
    </el-dialog>
    <el-dialog
      title="延时消息"
      :visible.sync="delayedMsgVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      wdith="990px"
    >
      <ded-msg-list
        ref="ded_msg_list"
      />
    </el-dialog>

    <el-dialog
      title="内推链接"
      :visible.sync="actionSetsDialogVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <!-- 列表 -->
      <el-table :data="paginatedActionSets" border style="width:100%;margin-bottom:10px;">
        <el-table-column label="广告主ID/名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.account_name }}({{ scope.row.account_id }})
          </template>
        </el-table-column>
        <el-table-column label="数据源ID/名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.name }}({{ scope.row.user_action_set_id }})
          </template>
        </el-table-column>
        <el-table-column label="内推链接" align="center">
          <template slot-scope="scope">
            <span>
              {{ getActionSetLinkForDialog(scope.row) }}
              <i
                v-clipboard:copy="getActionSetLinkForDialog(scope.row)"
                v-clipboard:success="onCopys"
                v-clipboard:error="onErrors"
                class="el-icon-document-copy"
                style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer; margin-left:6px;"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <pagination-right
        ref="actionSetsPagination"
        :current-page="actionSetsPage"
        :page-sizes="[10,20,50]"
        :total="actionSetsTotal"
        @size-change="changeActionSetsPageSize"
        @current-change="changeActionSetsPage"
      />
    </el-dialog>

    <el-dialog
      title="同步配置"
      :visible.sync="syncDialogVisible"
      width="500px"
    >
      <el-input v-model="syncInput" placeholder="请输入广告主ID" style="margin-bottom:20px;" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSyncDialog">取消</el-button>
        <el-button type="primary" @click="confirmSync">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="更新 SecretKey"
      :visible.sync="updateSecretDialogVisible"
      width="500px"
    >
      <el-input
        v-model="updateSecret.secret_key"
        placeholder="请输入SecretKey"
        style="margin-bottom:20px;"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateSecret">取消</el-button>
        <el-button type="primary" @click="submitUpdateSecret">确定</el-button>
      </div>
    </el-dialog>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletuww"
      width="50%"
      append-to-body
    >
      <TencentCloudChooseimgr
        ref="TencentCloudChooseimgrview"
        @clickicon="chuantu"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  adRedPacketWithdrawConfigList,
  adRedPacketWithdrawList,
  adRedPacketCoinList,
  adRedPacketWithdrawConfigDelete,
  adRedPacketWithdrawConfigSetDefault,
  adRedPacketChatList,
  adRedPacketChatBatchCreate,
  adRedPacketChatBatchDelete,
  adRedPacketChatUpdate,
  iqiyipromotionlinklist,
  iqiyipromotionlinkdel,
  kiadwertwqw,
  adDataSource,
  syncData,
  updateSecretKey,
  updateHkDefault,
  updateHkStatus
} from '@/api/bserw'
import PaginationRight from '@/components/PaginationRight/index.vue'
import WithdrawDialog from './components/withdrawdialog.vue'
import activation from './components/activation.vue'
import DedMsgList from '@/views/redenvelope/components/dedMsgList.vue'
import TencentCloudChooseimgr from './components/TencentCloudChooseimg.vue'
export default {
  components: { PaginationRight, WithdrawDialog, activation, DedMsgList, TencentCloudChooseimgr },
  data() {
    return {
      activeTab: 'link',
      // 提现配置
      configLoading: false,
      configList: [],
      configTotal: 0,
      configQuery: { page: 1, pageSize: 10 },
      // 提现记录
      withdrawLoading: false,
      withdrawList: [],
      withdrawTotal: 0,
      withdrawQuery: { page: 1, pageSize: 10 },
      // 金币记录
      coinLoading: false,
      coinList: [],
      coinTotal: 0,
      coinQuery: { page: 1, pageSize: 10 },
      // 聊天记录
      chatLoading: false,
      chatList: [],
      chatTotal: 0,
      chatQuery: { page: 1, pageSize: 10 },
      chatSelectionIds: [],
      chatDialogVisible: false,
      chatDialogMode: 'create', // create | edit
      chatSubmitting: false,
      chatForm: {
        id: null,
        chat_type: 1,
        contentText: '',
        imgArr: [''],
        newsItems: [{ content: '', img: '' }]
      },
      objr: {
        page: 1,
        pageSize: 10,
        keywords: null,
        onlyMe: 2,
        default_a: 0
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内推广链接'
        },
        {
          value: 2,
          label: '我关联的推广链接'
        }
      ],
      defaultarr: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '非默认页面'
        },
        {
          value: 2,
          label: '默认页'
        }
      ],
      loading: false,
      newtotalr: null,
      tableData: [],
      // 多选选中的行
      multipleSelection: [],
      dialogVisible: false,
      delayedMsgVisible: false,

      // action_sets 弹窗相关
      actionSetsDialogVisible: false,
      currentActionSetsRow: null,
      actionSetsPage: 1,
      actionSetsPageSize: 10,

      syncDialogVisible: false,
      syncInput: '',

      configListnew: [],
      configTotalnew: 0,
      configSearch: {
        app_id: '',
        keyword: '',
        user_action_set_id: '',
        page: 1,
        pageSize: 10
      },
      currentPagePath: '',
      globalLoading: false,
      updateSecret: {
        account_id: '',
        user_action_set_id: '',
        secret_key: ''
      },
      updateSecretDialogVisible: false,
      dialogVisibletuww: false,
      chatPickType: null, // 'img' | 'news'
      chatPickIndex: null
    }
  },
  computed: {
    // 分页后的 action_sets
    paginatedActionSets() {
      if (!this.currentActionSetsRow || !this.currentActionSetsRow.action_sets) {
        return []
      }
      const start = (this.actionSetsPage - 1) * this.actionSetsPageSize
      const end = start + this.actionSetsPageSize
      return this.currentActionSetsRow.action_sets.slice(start, end)
    },
    // action_sets 总数
    actionSetsTotal() {
      if (!this.currentActionSetsRow || !this.currentActionSetsRow.action_sets) {
        return 0
      }
      return this.currentActionSetsRow.action_sets.length
    }
  },
  created() {
    this.menuList()
  },
  methods: {
    handleTabClick() {
      if (this.activeTab === 'link') this.menuList()
      if (this.activeTab === 'config') this.fetchConfigList()
      if (this.activeTab === 'withdraw') this.fetchWithdrawList()
      if (this.activeTab === 'coin') this.fetchCoinList()
      if (this.activeTab === 'chat') this.fetchChatList()
      if (this.activeTab === 'datasource') this.loadConfigList()
    },
    openCreateConfig() {
      this.$refs.withdrawDialog.open()
    },
    openEditConfig(row) {
      this.$refs.withdrawDialog.open(row)
    },
    handleToggleDefault(row, val) {
      const target = val ? 2 : 1
      if (row.config_default === target) return
      const text = target === 2 ? '设置为默认' : '取消默认'
      this.$confirm(`确定要${text}该配置吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return adRedPacketWithdrawConfigSetDefault({ id: row.id, config_default: target })
      }).then(() => {
        this.$message.success(`${text}成功`)
        this.fetchConfigList()
      }).catch(() => {
        // 取消或失败时刷新一次列表还原状态
        this.fetchConfigList()
      })
    },
    handleDeleteConfig(row) {
      this.$confirm('此操作将删除该提现配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return adRedPacketWithdrawConfigDelete({ id: row.id })
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchConfigList()
      }).catch(() => {
        // 取消或错误已提示，不再处理
      })
    },
    // 分转元展示（列表用）
    configFenToYuan(fen) {
      if (fen == null || fen === '') return '-'
      return (Number(fen) / 100).toFixed(2)
    },
    // 提现配置列表
    fetchConfigList() {
      this.configLoading = true
      adRedPacketWithdrawConfigList(this.configQuery)
        .then(res => {
          this.configList = res.data?.list ?? res.data ?? []
          this.configTotal = res.data?.total ?? this.configList.length
        })
        .finally(() => {
          this.configLoading = false
        })
    },
    configSizeChange(size) {
      this.configQuery.pageSize = size
      this.configQuery.page = 1
      this.fetchConfigList()
    },
    configPageChange(page) {
      this.configQuery.page = page
      this.fetchConfigList()
    },
    // 提现记录列表
    fetchWithdrawList() {
      this.withdrawLoading = true
      adRedPacketWithdrawList(this.withdrawQuery)
        .then(res => {
          this.withdrawList = res.data?.list ?? res.data ?? []
          this.withdrawTotal = res.data?.total ?? this.withdrawList.length
        })
        .finally(() => {
          this.withdrawLoading = false
        })
    },
    withdrawSizeChange(size) {
      this.withdrawQuery.pageSize = size
      this.withdrawQuery.page = 1
      this.fetchWithdrawList()
    },
    withdrawPageChange(page) {
      this.withdrawQuery.page = page
      this.fetchWithdrawList()
    },
    // 金币记录列表
    fetchCoinList() {
      this.coinLoading = true
      adRedPacketCoinList(this.coinQuery)
        .then(res => {
          this.coinList = res.data?.list ?? res.data ?? []
          this.coinTotal = res.data?.total ?? this.coinList.length
        })
        .finally(() => {
          this.coinLoading = false
        })
    },
    // 聊天记录
    fetchChatList() {
      this.chatLoading = true
      adRedPacketChatList(this.chatQuery).then(res => {
        this.chatList = res.data?.list ?? res.data ?? []
        this.chatTotal = res.data?.total ?? this.chatList.length
      }).finally(() => {
        this.chatLoading = false
      })
    },
    chatSizeChange(size) {
      this.chatQuery.pageSize = size
      this.chatQuery.page = 1
      this.fetchChatList()
    },
    chatPageChange(page) {
      this.chatQuery.page = page
      this.fetchChatList()
    },
    onChatSelectionChange(rows) {
      this.chatSelectionIds = (rows || []).map(r => r.id).filter(Boolean)
    },
    openChatCreate() {
      this.chatDialogMode = 'create'
      this.resetChatDialog()
      this.chatDialogVisible = true
    },
    openChatEdit(row) {
      this.chatDialogMode = 'edit'
      this.resetChatDialog()
      this.chatForm.id = row.id
      const t = Number(row.chat_type)
      this.chatForm.chat_type = t
      if (t === 1) {
        if (Array.isArray(row.content)) {
          this.chatForm.contentText = row.content.join('\n')
        } else {
          this.chatForm.contentText = row.content ? String(row.content) : ''
        }
      } else if (t === 2) {
        const imgs = this.normalizeChatImg(row.img)
        this.chatForm.imgArr = (imgs && imgs.length ? imgs.slice() : [''])
      } else if (t === 3) {
        const news = this.normalizeChatNews(row.news)
        this.chatForm.newsItems = news.length ? news.map(n => ({ content: n.content || '', img: n.img || '' })) : [{ content: '', img: '' }]
      }
      this.chatDialogVisible = true
    },
    resetChatDialog() {
      this.chatSubmitting = false
      this.chatForm = {
        id: null,
        chat_type: 1,
        contentText: '',
        imgArr: [''],
        newsItems: [{ content: '', img: '' }]
      }
    },
    addChatImgItem() {
      this.chatForm.imgArr.push('')
    },
    removeChatImgItem(idx) {
      if (this.chatForm.imgArr.length <= 1) return
      this.chatForm.imgArr.splice(idx, 1)
    },
    openChatImgPicker(idx) {
      this.chatPickType = 'img'
      this.chatPickIndex = idx
      this.aweq()
    },
    openChatNewsImgPicker(idx) {
      this.chatPickType = 'news'
      this.chatPickIndex = idx
      this.aweq()
    },
    addNewsItem() {
      this.chatForm.newsItems.push({ content: '', img: '' })
    },
    removeNewsItem(idx) {
      if (this.chatForm.newsItems.length <= 1) return
      this.chatForm.newsItems.splice(idx, 1)
    },
    copyToClipboard(text) {
      const str = String(text ?? '')
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(str).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.fallbackCopy(str)
        })
      } else {
        this.fallbackCopy(str)
      }
    },
    fallbackCopy(str) {
      const ta = document.createElement('textarea')
      ta.value = str
      ta.style.position = 'fixed'
      ta.style.top = '-1000px'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (e) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(ta)
    },
    // 聊天记录：兼容后端返回 string/JSON-string/array/object
    safeJsonParse(val) {
      if (typeof val !== 'string') return val
      const s = val.trim()
      if (!s) return val
      try {
        return JSON.parse(s)
      } catch (e) {
        return val
      }
    },
    normalizeChatImg(img) {
      if (!img) return []
      const parsed = this.safeJsonParse(img)
      if (Array.isArray(parsed)) return parsed
      if (typeof parsed === 'string') return parsed ? [parsed] : []
      return []
    },
    normalizeChatNews(news) {
      if (!news) return []
      const parsed = this.safeJsonParse(news)
      // 兼容：news 可能是数组，也可能是单个对象 {content,img}
      if (Array.isArray(parsed)) return parsed
      if (parsed && typeof parsed === 'object') return [parsed]
      // 后端可能给空字符串或 "{}"
      return []
    },
    copyChatJson(kind) {
      if (kind === 'img') {
        const arr = (this.chatForm.imgArr || []).map(s => (s || '').trim()).filter(Boolean)
        this.copyToClipboard(JSON.stringify({ img: arr }))
      } else if (kind === 'news') {
        const arr = (this.chatForm.newsItems || []).map(it => ({ content: (it.content || '').trim(), img: (it.img || '').trim() })).filter(it => it.content || it.img)
        this.copyToClipboard(JSON.stringify({ news: arr }))
      }
    },
    submitChatDialog() {
      const t = Number(this.chatForm.chat_type)
      const payload = { chat_type: t }
      if (t === 1) {
        // 文本：新增依旧按数组传；编辑时后端需要 string：content: 'xxx'
        const arr = (this.chatForm.contentText || '').split('\n').map(s => s.trim()).filter(Boolean)
        if (!arr.length) {
          this.$message.error('请输入文本内容')
          return
        }
        if (this.chatDialogMode === 'edit') {
          payload.content = arr.join('\n')
        } else {
          payload.content = arr
        }
      } else if (t === 2) {
        // 图片：新增按数组传；编辑时后端需要 string：img: 'xxx'
        const arr = (this.chatForm.imgArr || []).map(s => (s || '').trim()).filter(Boolean)
        if (!arr.length) {
          this.$message.error('请至少上传一张图片')
          return
        }
        if (this.chatDialogMode === 'edit') {
          payload.img = arr[0] || ''
        } else {
          payload.img = arr
        }
      } else if (t === 3) {
        const arr = (this.chatForm.newsItems || []).map(it => ({
          content: (it.content || '').trim(),
          img: (it.img || '').trim()
        })).filter(it => it.content || it.img)
        // 图文：必须填写文本内容且上传图片
        if (!arr.length || arr.some(it => !it.img || !it.content)) {
          this.$message.error('图文类型每条必须填写文本内容并上传图片')
          return
        }
        // 图文：新增按数组传；编辑时后端需要 object：news: {content,img}
        if (this.chatDialogMode === 'edit') {
          payload.news = arr[0] || { content: '', img: '' }
        } else {
          payload.news = arr
        }
      }

      this.chatSubmitting = true
      const req = this.chatDialogMode === 'edit'
        ? adRedPacketChatUpdate({ id: this.chatForm.id, ...payload })
        : adRedPacketChatBatchCreate(payload)
      req.then(() => {
        this.$message.success(this.chatDialogMode === 'edit' ? '更新成功' : '创建成功')
        this.chatDialogVisible = false
        this.fetchChatList()
      }).finally(() => {
        this.chatSubmitting = false
      })
    },
    deleteChat(row) {
      this.$confirm('确认删除该聊天记录？', '提示', { type: 'warning' }).then(() => {
        return adRedPacketChatBatchDelete({ ids: [row.id] })
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchChatList()
      }).catch(() => {})
    },
    batchDeleteChat() {
      this.$confirm('确认删除选中的聊天记录？', '提示', { type: 'warning' }).then(() => {
        return adRedPacketChatBatchDelete({ ids: this.chatSelectionIds })
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchChatList()
      }).catch(() => {})
    },
    coinSizeChange(size) {
      this.coinQuery.pageSize = size
      this.coinQuery.page = 1
      this.fetchCoinList()
    },
    coinPageChange(page) {
      this.coinQuery.page = page
      this.fetchCoinList()
    },
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await iqiyipromotionlinklist(this.objr)
      console.log('data', data)
      this.tableData = []
      this.tableData = data.data.list
      this.newtotalr = data.data.total
      this.loading = false
    },
    sraw() {
      this.objr.page = 1
      // this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      // this.objr.page_size = 10
      this.objr.keywords = null
      this.objr.onlyMe = 2
      this.objr.default_a = 0
      this.menuList()
    },
    // 处理表格多选变化
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    // 批量删除方法（用户自己补充实现）
    handleBatchDelete() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }
      this.$confirm('确定要删除吗？', '提示').then(() => {
        // 从选中的对象数组中提取 iqiyi_promotion_link_no 值组成数组
        const iqiyiPromotionLinkNos = this.multipleSelection.map(item => item.iqiyi_promotion_link_no)
        iqiyipromotionlinkdel({
          iqiyi_promotion_link_nos: iqiyiPromotionLinkNos
        }).then(res => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.multipleSelection = [] // 清空选中项
          this.menuList()
        })
      })
    },
    addbit() {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.activationview.send(1)
      }, 100)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.objr.page = 1
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    formatCopy(row) {
      return `${row.title}
小程序：${row.account_name}${row.gh_id}
路径：${row.page_path}&user_action_set_id=${row.action_sets?.[0]?.user_action_set_id ?? ''}`
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onErrors() {
      this.$message.error('复制失败')
    },
    // 获取 action_set 链接
    getActionSetLink(row, index) {
      if (!row.action_sets || !row.action_sets[index] || !row.page_path) {
        return ''
      }
      return `${row.page_path}&user_action_set_id=${row.action_sets[index].user_action_set_id}`
    },
    unBindStatusUpdate(val, item) {
      console.log(val, item)
      kiadwertwqw({
        iqiyi_promotion_link_no: item.iqiyi_promotion_link_no,
        default_a: val
      }).then((res) => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.menuList()
        }
      })
    },
    lookdata(item) {
      console.log(item)
      this.$router.push({
        path: '/miniprogramoption/miniprogramaccess',
        query: {
          appid: item.app_id,
          is_show: true
        }
      })
    },
    async exportlisrwdaw(id) {
      console.log('item', id)
      this.$confirm('确定要删除吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          console.log('666')
          iqiyipromotionlinkdel({
            iqiyi_promotion_link_nos: [id]
          }).then(res => {
            console.log('res', res)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.menuList()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    exportledit(item) {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.activationview.send(2, item)
      }, 100)
    },
    reusedawrq(item) {
      this.$confirm('确定要复用吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          this.dialogVisible = true
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.activationview.send(3, item)
          }, 100)
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    getDelayedMsg(item) {
      this.delayedMsgVisible = true
      setTimeout(() => {
        // // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.ded_msg_list.send(item)
      }, 100)
    },
    // 打开 action_sets 弹窗
    openActionSetsDialog(row) {
      this.currentActionSetsRow = row
      this.actionSetsPage = 1
      this.actionSetsDialogVisible = true
    },
    // 获取弹窗中的内推链接
    getActionSetLinkForDialog(actionSet) {
      if (!this.currentActionSetsRow || !this.currentActionSetsRow.page_path) {
        return ''
      }
      return `${this.currentActionSetsRow.page_path}&user_action_set_id=${actionSet.user_action_set_id}`
    },
    // action_sets 分页相关
    changeActionSetsPage(page) {
      this.actionSetsPage = page
    },
    changeActionSetsPageSize(size) {
      this.actionSetsPageSize = size
      this.actionSetsPage = 1
    },
    // 打开设置数据源（从推广链接页面跳转）
    openSetDataSource(row) {
      // 切换到数据源页面
      this.activeTab = 'datasource'
      // 如果有 account_id，预填充到同步输入框
      if (row.account_id) {
        this.syncInput = row.account_id
      } else {
        this.syncInput = ''
      }
      // 打开同步数据源弹窗
      this.syncDialogVisible = true
      // 加载数据源列表
      this.$nextTick(() => {
        this.loadConfigList()
      })
    },
    async loadConfigList() {
      this.globalLoading = true
      try {
        const res = await adDataSource(this.configSearch)
        this.configListnew = res.data.list
        this.configTotalnew = res.data.total
      } finally {
        this.globalLoading = false
      }
    },
    resetConfigPage() {
      this.configSearch.app_id = ''
      this.configSearch.user_action_set_id = ''
      this.configSearch.page = 1
      this.currentPagePath = ''
      this.loadConfigList()
    },
    // 同步弹窗逻辑
    openSyncDialog() {
      this.syncInput = ''
      this.syncDialogVisible = true
    },
    closeSyncDialog() {
      this.syncInput = ''
      this.syncDialogVisible = false
    },
    async confirmSync() {
      if (!this.syncInput) {
        this.$message.error('account_id 不能为空')
        return
      }
      try {
        await syncData({ account_id: this.syncInput })
        this.$message.success('同步成功')
        this.closeSyncDialog()
        this.loadConfigList() // 同步成功后刷新父列表
      } catch (e) {
        this.$message.error('同步失败，请重试')
      }
    },
    changeConfigPageSize(size) {
      this.configSearch.pageSize = size
      this.loadConfigList()
    },
    changeConfigPage(page) {
      this.configSearch.page = page
      this.loadConfigList()
    },
    // 更新SecretKey
    openUpdateSecret(row) {
      this.updateSecret = {
        account_id: row.account_id,
        user_action_set_id: row.user_action_set_id,
        secret_key: ''
      }
      this.updateSecretDialogVisible = true
    },
    closeUpdateSecret() {
      this.updateSecret = { account_id: '', user_action_set_id: '', secret_key: '' }
      this.updateSecretDialogVisible = false
    },
    async submitUpdateSecret() {
      if (!this.updateSecret.secret_key) {
        this.$message.error('SecretKey不能为空')
        return
      }
      await updateSecretKey(this.updateSecret)
      this.$message.success('更新成功')
      this.closeUpdateSecret()
      this.loadConfigList()
    },
    // 处理是否默认开关变化
    handleHkDefaultChange(val, row) {
      // val是新值，计算旧值（1和2互转）
      const oldValue = val === 2 ? 1 : 2
      updateHkDefault({
        account_id: row.account_id,
        user_action_set_id: row.user_action_set_id,
        hk_default: val
      }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.loadConfigList()
        } else {
          // 如果失败，恢复原值
          this.$set(row, 'hk_default', oldValue)
        }
      }).catch(() => {
        // 如果失败，恢复原值
        this.$set(row, 'hk_default', oldValue)
        this.$message.error('操作失败，请重试')
      })
    },
    // 处理状态开关变化
    handleHkStatusChange(val, row) {
      // val是新值，计算旧值（1和2互转）
      // 1是打开，2是关闭
      const oldValue = val === 1 ? 2 : 1
      updateHkStatus({
        account_id: row.account_id,
        user_action_set_id: row.user_action_set_id,
        hk_status: val
      }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.loadConfigList()
        } else {
          // 如果失败，恢复原值
          this.$set(row, 'hk_status', oldValue)
        }
      }).catch(() => {
        // 如果失败，恢复原值
        this.$set(row, 'hk_status', oldValue)
        this.$message.error('操作失败，请重试')
      })
    },
    aweq() {
      this.dialogVisibletuww = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.TencentCloudChooseimgrview.parentHandleclick('1')
      }, 100)
    },
    chuantu(img) {
      this.dialogVisibletuww = false
      // 聊天记录图片选择：回填到数组指定项
      if (this.chatPickType === 'img' && this.chatPickIndex !== null && this.chatForm && Array.isArray(this.chatForm.imgArr)) {
        this.$set(this.chatForm.imgArr, this.chatPickIndex, img)
        this.chatPickType = null
        this.chatPickIndex = null
        return
      }
      if (this.chatPickType === 'news' && this.chatPickIndex !== null && this.chatForm && Array.isArray(this.chatForm.newsItems)) {
        this.$set(this.chatForm.newsItems[this.chatPickIndex], 'img', img)
        this.chatPickType = null
        this.chatPickIndex = null
        return
      }
      console.log('img', img)
    }
  }
}
</script>
<style scoped>
.yuan-tip {
  color: #909399;
  font-size: 12px;
}
.withdrawal-tag {
  display: inline-block;
  margin: 0 4px 4px 0;
  padding: 2px 6px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 12px;
}
</style>
